<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
            <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-radio-group class="pa-0 ma-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                            <v-radio label="Attivo" value="on"></v-radio>
                            <v-radio label="Disattivo" value="off"></v-radio>
                            <v-radio label="Fuori zona intervento" value="out"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6" class="pa-1">
                        <NumericField dense outlined
                            @input="changeMass"
                            class="pa-0 ma-0"
                            label="valore iniziale"
                            :readonly="preview"
                            v-model="measures.zero_val"
                            :precision="currentPrecision"
                            :negative="false"
                            :suffix="data.instrument_data.uom"
                        ></NumericField>
                    </v-col>
                    <v-col cols="6" class="pa-1">
                        <NumericField dense outlined
                            @input="changeMass"
                            class="pa-0 ma-0"
                            label="valore nominale"
                            :readonly="preview"
                            v-model="measures.mass"
                            :precision="currentPrecision"
                            :negative="false"
                            :suffix="data.instrument_data.uom"
                            :class="readingWarning(measures.mass)"
                        ></NumericField>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-img max-width="230" max-height="100" :src="image_data" />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-end" v-if="!preview">
                        <v-btn color="primary" @click="handlePlaceholders(measures.items)">Riempimento automatico</v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <span class="subtitle-2"><b>{{'Da sinistra'}}</b></span>
                </v-row>
                <v-row no-gutters>
                    <v-simple-table class="measure_table">
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="table-text-blocks text-right">{{data.block.conf.headers.pos}}</th>
                            <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                            <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                            <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                            <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        </tr>
                        </thead>
                        <tr v-for="(item,index) of measures.items_left" :key="index">
                        <td class="table-blocks d-flex align-center">
                            <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index > measures.points && !preview" @click="removeRow(index)">delete</v-icon>
                            <div v-else class="d-flex mr-6"></div>
                            <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{item.position}}</div>
                        </td>
                        <td class="table-blocks" v-if="index == 0" :rowspan="measures.items_left.length">
                            <NumericField dense outlined disabled v-model="item.mass" hide-details ></NumericField>
                        </td>
                        <td class="table-blocks">
                            <NumericField dense outlined
                            solo hide-details
                            :readonly="preview"
                            v-model="item.reading"
                            :precision="currentPrecision"
                            :negative="false"
                            class="text-left"
                            :class="readingWarning(item.reading)"
                            @input="changeReading(item)" 
                            :placeholder="readingPlaceholder(item.mass)"
                            ></NumericField>
                        </td>
                        <td class="table-blocks"  v-if="measures.hi_res == 'off'">
                            <NumericField dense outlined
                            @input="changeAddLoad(item)"
                            solo hide-details
                            class="text-left"
                            :readonly="preview"
                            v-model="item.addLoad"
                            :precision="high_precision"
                            :negative="false"
                            :placeholder="calculateAddLoadPlaceholder(item.reading)"
                            :class="addLoadWarning(item.addLoad, item.reading)"
                            :enableicons="!preview"
                            :addfunc="loadAddFunc"
                            :subfunc="loadSubFunc"
                            :row="item"
                            :fieldname="'addLoad'"
                            :range="calcMinRange(item.reading)"
                            ></NumericField>
                        </td>
                        <td class="table-text-blocks text-right" v-if="measures.hi_res == 'off'"><b>{{item.p | formatNumber}}</b></td>
                    </tr>
                    </template>                    
                    </v-simple-table>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                        <div v-if="precision_overflow_left" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                        <div v-if="addLoad_overflow_left" class="error--text caption"><StatusIcon status="failed" small/><b>Controlla carico addizionale</b></div>
                    </div>        
                </v-row>
                <v-row no-gutters>
                    <span class="subtitle-2"><b>{{'Da destra'}}</b></span>
                </v-row>
                <v-row no-gutters>
                    <v-simple-table class="measure_table">
                        <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="table-text-blocks text-right">{{data.block.conf.headers.pos}}</th>
                            <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                            <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                            <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                            <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        </tr>
                        </thead>
                        <tr v-for="(item,index) of measures.items_right" :key="index">
                        <td class="table-blocks d-flex align-center">
                            <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{item.position}}</div>
                        </td>
                        <td class="table-blocks" v-if="index == 0" :rowspan="measures.items_right.length">
                            <NumericField dense outlined disabled v-model="item.mass" hide-details ></NumericField>
                        </td>
                        <td class="table-blocks">
                            <NumericField dense outlined
                            solo hide-details
                            :readonly="preview"
                            v-model="item.reading"
                            :precision="currentPrecision"
                            :negative="false"
                            class="text-left"
                            :class="readingWarning(item.reading)"
                            @input="changeReading(item)" 
                            :placeholder="readingPlaceholder(item.mass)"
                            ></NumericField>
                        </td>
                        <td class="table-blocks"  v-if="measures.hi_res == 'off'">
                            <NumericField dense outlined
                            @input="changeAddLoad(item)"
                            solo hide-details
                            class="text-left"
                            :readonly="preview"
                            v-model="item.addLoad"
                            :precision="high_precision"
                            :negative="false"
                            :placeholder="calculateAddLoadPlaceholder(item.reading)"
                            :class="addLoadWarning(item.addLoad, item.reading)"
                            ></NumericField>
                        </td>
                        <td class="table-text-blocks text-right" v-if="measures.hi_res == 'off'"><b>{{item.p | formatNumber}}</b></td>
                    </tr>
                    </template>                    
                    </v-simple-table>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                        <div v-if="precision_overflow_right" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                        <div v-if="addLoad_overflow_right" class="error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                    </div>        
                    <div class="d-flex flex-grow-0 flex-shrink-1 my-2">
                        <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                    </div>
                </v-row>
                <v-row no-gutters class="d-flex justify-end">
                    <div class="add_table text-center elevation-2 mb-2">
                        <table class="py-2 px-6">
                            <tr><td class="text-right">Carico da 1 a 6:</td><td class="text-right pl-2"><b>{{totalReading | formatNumber}} {{this.instrument_data.uom}}</b></td></tr>
                            <tr><td class="text-right">
                                <span v-if="measures.hi_res=='off'">Pmax - Pmin:</span>
                                <span v-else>Imax - Imin:</span></td><td class="text-right pl-2"><b>{{measures.diff | formatNumber}} {{this.instrument_data.uom}}</b>
                            </td></tr>
                            <tr><td class="text-right">MPE:</td><td class="text-right pl-2"><b>{{measures.mpe | formatNumber}} {{this.instrument_data.uom}}</b></td></tr>
                            <tr><td class="text-right">
                                ESITO:</td>
                                <td class="text-right pl-2">
                                <StatusIcon :status="measures.result" :tooltip_text="block_tooltip[measures.result]" />
                            </td></tr>
                        </table>
                    </div>
                </v-row>
            </v-container>
        </div>
    </LayoutBlock>
</template>

<script>

import {eccentricity_item} from "../../../utils/itemBlockSchema"
import {BaseLeg} from "../../../utils/baseLeg"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from "../../../components/utils/StatusIcon"
import Big from "big.js"
// // import _ from 'lodash'

export default {
    components: {LayoutBlock, StatusIcon},    
    mixins: [BaseLeg],

    data(){
        return{
            shapes: [ 
                {shape: 'triangle', text: 'triangolare'},
                {shape: 'square', text: 'rettangolare'},
                {shape: 'circle', text: 'circolare'},
                {shape: 'ellipsis', text: 'ellittica'},
            ],
        }
    },
    computed: {
        precision_overflow_right() {
            for (let elm of this.measures.items_right) {
                let res = this.checkReading(elm.reading)
                switch (res) {
                    case 'uncomplete':
                    case 'done':
                        break
                    case 'failed':
                        return true
                }
            }
            return false
        }, 
        precision_overflow_left() {
            for (let elm of this.measures.items_left) {
                let res = this.checkReading(elm.reading)
                switch (res) {
                    case 'uncomplete':
                    case 'done':
                        break
                    case 'failed':
                        return true
                }
            }
            return false
        },
        addLoad_overflow_left() {
            if (this.measures.hi_res == 'off') {
                for (let elm of this.measures.items_left) {
                    if (!this.checkLoad(elm.addLoad, elm.reading)) {
                        return true
                    }
                } return false
            } else {
                return false
            }
        },  
        addLoad_overflow_right() {
            if (this.measures.hi_res == 'off') {
                for (let elm of this.measures.items_right) {
                    if (!this.checkLoad(elm.addLoad, elm.reading)) {
                        return true
                    }
                } return false
            } else {
                return false
            }
        }, 
        totalReading(){
            let temp = Big(0);
            if(this.measures.hi_res == 'off'){
                for(let item of this.measures.items_left){
                    if(item.p){
                        temp = temp.plus(item.p)
                    }
                }
                for(let item of this.measures.items_right){
                    if(item.p){
                        temp = temp.plus(item.p)
                    }
                }
            } else {
                for(let item of this.measures.items_left){
                    if(item.reading){
                        temp = temp.plus(item.reading)
                    }
                }
                for(let item of this.measures.items_right){
                    if(item.reading){
                        temp = temp.plus(item.reading)
                    }
                }
            }
            return this.round(temp, this.high_precision);
        }
    },
    methods: {
        async buildMeasures(){
            this.measures = {
                items_left: [],
                items_right: [],
                shape: null,
                zero_device: this.conf.zero_device,
                hi_res: this.conf.hi_res,
                zero_val: "0",
                mass: "0",
                mpe: "0",
                points: 0,
                diff: "0",
                result: 'uncomplete'
            }
            this.measures.hi_res = this.has_hi_res ? this.conf.hi_res : 'off'
            this.measures.points = 3
            await this.getImageID()
            await this.getImage()
            if(this.data.instrument_data != null){
                let currentRange = this.instrument_data.ranges[0]
                this.measures.zero_val = Big(currentRange.e).times(10).toString()
                let catMass = await this.buildWithCategory()
                this.measures.mass = catMass ? catMass : this.round(0)
                this.measures.mpe = this.calc_MPE(currentRange, this.measures.mass)
            }
            for (let i = 0; i< this.measures.points; i++){
                this.addRow()
            }
            this.changeMass()
        },
        addRow(){
            let item = eccentricity_item({
                position: this.measures.items_left.length,
            })
            // console.log("$$ debug item", item)
            this.measures.items_left.push(item)
            this.measures.items_right.push(_.cloneDeep(item))
            this.changeMass()
        },
        changeMass(){
            if(this.measures.mass){
                let zero = Big(this.measures.zero_val)
                let temp = zero.plus(this.measures.mass).toString()
                let currRange = this.calcMinRange(temp)
                let mpe = this.calc_MPE(currRange, temp)
                for(let i=0;i<this.measures.items_left.length;i++){
                    this.measures.items_left[i].mass = temp
                    this.measures.items_left[i].mpe = mpe
                    this.measures.items_right[i].mass = temp
                    this.measures.items_right[i].mpe = mpe
                }
                // if(this.measures.items && this.measures.items.length > 0){
                //     this.measures.items_left[0].mass = zero.toString()
                //     this.measures.items_left[0].mpe = this.calc_MPE(currRange, zero.toString())
                // }
                this.measures.mpe = mpe
            }
        },
        calcError(row){
            if(row){
                if(this.measures.hi_res == 'on'){
                    row.error = this.differenceInt(row.reading, row.mass)
                    this.calculateResult(row)
                } else {
                    row.error = this.differenceInt(row.p, row.mass)
                    if(this.checkLoad(row.addLoad, row.mass)){
                        this.calculateResult(row)
                    } else {
                        row.result = 'failed'
                    }
                }
            }
        },
        calcBlockResult() {
            // console.log('CALC BLOCK RESULT')
            let result_up = 'done'
            result_up = this.measures.items_right.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let result_down = 'done'
            result_down = this.measures.items_left.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            // console.log('CALC BLOCK RESULT', result_up, result_down)
            if (result_up == result_down) {
                if (result_up == 'done') {
                    if(this.precision_overflow_right && this.precision_overflow_left){
                        this.measures.result = 'failed' 
                    } else if(this.measures.hi_res == 'off' && (this.addLoad_overflow_left || this.addLoad_overflow_right) ){
                        this.measures.result = 'failed'
                    } else {
                        this.measures.result = Big(this.measures.diff).lte(this.measures.mpe) ? 'done' : 'failed'
                    }
                } else {
                    this.measures.result = result_up
                }
            } else if (result_up == 'uncomplete' || result_down == 'uncomplete') {
                this.measures.result = 'uncomplete'
            } else if (result_up == 'failed' || result_down == 'failed') {
                this.measures.result = 'failed'
            }
        },
        // calcDiff(){
        //     let start_error_L = null
        //     for(let i=0; i<this.measures.items_right.length;i++){
        //         let rowL = this.measures.items_left[i]
        //         this.calcError(rowL)
        //         let rowR = this.measures.items_right[i]
        //         this.calcError(rowR)
        //         if(i == 0){
        //             start_error_L = rowL.error
        //             rowR.error_corr = this.differenceInt(rowR.error, start_error_L)
        //         } else {
        //             rowL.error_corr = this.differenceInt(rowL.error, start_error_L)
        //             rowR.error_corr = this.differenceInt(rowR.error, start_error_L)
        //         }
        //     }
        //     let rowL = this.measures.items_left[this.measures.items_left.length - 1]
        //     if(rowL){
        //         this.calcError(rowL)
        //         rowL.error_corr = this.differenceInt(rowL.error, start_error_L)
        //     }
        // },
        calcDiff(){
            let targets = [];
            for (let item of this.measures.items_left) {
                let t = 0
                if (this.measures.hi_res == 'off') {
                    t = item.p;
                } else {
                    t = item.reading;
                }
                targets.push(t)
            }
            for (let item of this.measures.items_right) {
                let t = 0
                if (this.measures.hi_res == 'off') {
                    t = item.p;
                } else {
                    t = item.reading;
                }
                targets.push(t)
            }
            let min = Math.min.apply(Math, targets);
            let max = Math.max.apply(Math, targets);
            this.measures.diff = this.differenceInt(max,min)
        },
        handlePlaceholders(){
            this.convertPlaceholders(this.measures.items_left)
            this.convertPlaceholders(this.measures.items_right)
        },
        removeRow(index){
            this.measures.items_left.splice(index,1)
            this.measures.items_right.splice(index -1,1)
        },
    }
}
</script>